<template>
  <div class="new_banner">
    <el-carousel trigger="click" :interval="5000" height="275px">
      <el-carousel-item v-for="item in focusesData" :key="item.id">
        <div v-if="cmsNodeChlid" class="cursor_pointer" @click="onBannerClick(item.id)">
          <img :src="item.cover+'!960'" alt="轮播图" style="width:438px;height:275px">
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex'
import Cookies from 'js-cookie'
export default {
  props: {
    cmsNodeChlid: {
      type: Object,
      default: () => null
    },

  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['siteInfo','focusesData'])
  },
  created() {
    this.initFocusesData()
  },
  methods: {
    ...mapActions({
      'initFocusesData':'cache/initFocusesData'
    }),
    // 轮播图点击 click
    onBannerClick(id) {
      Cookies.set('cmsNodeChlidId', this.cmsNodeChlid.id)
      this.$router.push(`${this.cmsNodeChlid.infoModel.route}/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.new_banner{
  width: 438px;

}
::v-deep .el-carousel__indicators{
    // right: 0 !important;
    // left: auto;
    // transform: translateX(0);
  }
</style>
